export const locations = [
  'Home / Residence',
  'Business',
  'Hospital',
  'Church',
  'School'
]
